export default class SentimentResult {
  constructor({score, positiveWords, negativeWords}) {
    this.score = score || 0
    this.positiveWords = positiveWords || {}
    this.negativeWords = negativeWords || {}
  }
}
